import { TimeOnly } from "../@client/System"

export const timeOnlyToMantineTime = (v: TimeOnly) => v.substring(0, 5)
